import { Box, TextField, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import { FieldRequiredMark } from './FieldRequiredMark';

export const FormControlledTextField = ({ name, control, rules, required, ...props }) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field, fieldState: { error } }) => (
      <FormTextField
        id={name}
        {...field}
        required={rules?.required || required}
        error={!!error}
        helperText={error?.message}
        {...props}
      />
    )}
  />
);

export const FormTextField = ({ id, label, ariaLabel, required, htmlInputProps, ...rest }) => {
  return (
    <Box>
      {label && (
        <Typography className="mss__label" component="label" htmlFor={id}>
          {label} {required && <FieldRequiredMark label={label} />}
        </Typography>
      )}
      <TextField
        id={id}
        size="small"
        aria-label={ariaLabel || label}
        slotProps={{ htmlInput: { 'aria-label': ariaLabel || label, ...htmlInputProps } }}
        {...rest}
      />
    </Box>
  );
};
